import { getTheme, } from "@bracket/ui/themes";
import type { Strata, ColorDeclaration, } from "@bracket/ui/types";



export const getStrataBackgroundColor = (strata: Strata): ColorDeclaration => {
	switch (strata) {
		case "lowest": return getTheme().surface_container_lowest;
		case "low": return getTheme().surface_container_low;
		case "default": return getTheme().surface_container;
		case "high": return getTheme().surface_container_high;
		case "highest": return getTheme().surface_container_highest;
		default: return getTheme().error;
	}
}
